/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["file-thumbnail{display:block;background-color:#fafafa}file-thumbnail img{display:block;max-width:100%;height:auto}"];
export { styles as styles };
